import React from 'react';
import {Link} from 'react-router-dom';

function ItemBreadcrumb (props) {
  const categoryUrl = "/"+props.catalogSlug+"/"+props.categorySlug+"/"+props.categoryId;

/*
  const itemUrl = "/"+props.catalogSlug+"/"+props.categorySlug+"/"+props.itemSlug+"/"+props.itemId;
        <p
          className="breadcrumbs-button"
          onclick="toggleDivDisplay('breadcrumbs')"
        >
          Percorso &gt;&gt;
        </p>
          <Link to={itemUrl}> {props.itemTitle}</Link>

*/
    return (
      <>
        <div id="breadcrumbs" className="breadcrumbs">
          <Link to="/"> Home</Link> &gt; 
          <Link to={"/"+props.catalogSlug}> {props.catalogText}</Link> &gt; 
          <Link to={categoryUrl}> {props.categoryTitle}</Link> &gt; 
          <span> {props.itemTitle}</span>
        </div>
      </>
    );
}

export default ItemBreadcrumb;